import { render, staticRenderFns } from "./RevenueReport.vue?vue&type=template&id=56b56cf2&scoped=true&"
import script from "./RevenueReport.vue?vue&type=script&lang=js&"
export * from "./RevenueReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b56cf2",
  null
  
)

export default component.exports